import fetchSMSProviders from './fetch-sms-providers'
import saveSMSProviders from './save-sms-providers'

const actions = {
  fetchSMSProviders,
  saveSMSProviders
}

export default actions
